import { render, staticRenderFns } from "./productEdit.vue?vue&type=template&id=470e77c9&scoped=true"
import script from "./productEdit.vue?vue&type=script&lang=js"
export * from "./productEdit.vue?vue&type=script&lang=js"
import style0 from "./productEdit.vue?vue&type=style&index=0&id=470e77c9&prod&lang=scss"
import style1 from "./productEdit.vue?vue&type=style&index=1&id=470e77c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470e77c9",
  null
  
)

export default component.exports